import { call, all, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "../constants";

import { getAccessToken } from "../../utils/jwt";

import { ServerResponse } from "node:http";
import apiClientForPScreen from "../apiClientForPScreen";

// Shooter function to fetch all substances
async function shooterGetAllSubstances(data: { cp?: number; ps?: number }) {
  const response = await apiClientForPScreen.get(
    `/psiloscreen/substances/getAll?cp=${data?.cp || 1}&ps=${data?.ps || 11}`,
    {
      headers: { Authorization: getAccessToken() },
    }
  );
  return response.data.records;
}

// Saga to handle fetching all substances
function* getAllSubstances(): any {
  yield takeLatest(actionTypes.GET_ALL_SUBSTANCES, function* (action: any) {
    try {
      const data: ServerResponse = yield call(
        shooterGetAllSubstances,
        action.payload
      );
      yield put({
        type: actionTypes.GET_ALL_SUBSTANCES_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.error(error);
    }
  });
}

// Shooter function to fetch all conditions
async function shooterGetAllConditions() {
  const response = await apiClientForPScreen.get(
    `/psiloscreen/conditions/getAll`,
    {
      headers: { Authorization: getAccessToken() },
    }
  );
  return response.data.records;
}

// Saga to handle fetching all conditions
function* getAllConditions(): any {
  yield takeLatest(actionTypes.GET_ALL_CONDITIONS, function* () {
    try {
      const data: ServerResponse = yield call(shooterGetAllConditions);
      yield put({
        type: actionTypes.GET_ALL_CONDITIONS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.error(error);
    }
  });
}

// Shooter function to fetch all allergies
async function shooterGetAllAllergies() {
  const response = await apiClientForPScreen.get(
    `/psiloscreen/allergies/getAll?ps=20`,
    {
      headers: { Authorization: getAccessToken() },
    }
  );
  return response.data.records;
}

// Saga to handle fetching all allergies
function* getAllAllergies(): any {
  yield takeLatest(actionTypes.GET_ALL_ALLERGIES, function* () {
    try {
      const data: ServerResponse = yield call(shooterGetAllAllergies);
      yield put({
        type: actionTypes.GET_ALL_ALLERGIES_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.error(error);
    }
  });
}

// Shooter function to fetch all contraindications
async function shooterGetAllContraindications(data: {
  cp?: number;
  ps?: number;
}) {
  const response = await apiClientForPScreen.get(
    `/psiloscreen/contra/getAllContra?cp=${data?.cp || 1}&ps=${data?.ps || 11}`,
    {
      headers: { Authorization: getAccessToken() },
    }
  );
  return response.data.records;
}

// Saga to handle fetching all contraindications
function* getAllContraindications(): any {
  yield takeLatest(
    actionTypes.GET_ALL_CONTRAINIDATIONS,
    function* (action: any) {
      try {
        const data: ServerResponse = yield call(
          shooterGetAllContraindications,
          action.payload
        );
        yield put({
          type: actionTypes.GET_ALL_CONTRAINIDATIONS_SUCCESS,
          payload: data,
        });
      } catch (error) {
        console.error(error);
      }
    }
  );
}

// Shooter function to fetch all groups
async function shooterGetAllGroups() {
  const response = await apiClientForPScreen.get(`/psiloscreen/groups/getAll`, {
    headers: { Authorization: getAccessToken() },
  });
  return response.data.records;
}

// Saga to handle fetching all groups
function* getAllGroups(): any {
  yield takeLatest(actionTypes.GET_ALL_GROUPS, function* () {
    try {
      const data: ServerResponse = yield call(shooterGetAllGroups);
      yield put({
        type: actionTypes.GET_ALL_GROUPS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.error(error);
    }
  });
}

// Root saga to run all sagas
export default function* runBlockingCallsExample() {
  yield all([
    getAllSubstances(),
    getAllConditions(),
    getAllAllergies(),
    getAllGroups(),
    getAllContraindications(),
  ]);
}
